import React from 'react';
import { Grid } from '@material-ui/core';
import propTypes from 'prop-types';
import logo from '../../assets/logo_coral.png';
import styles from './Base.module.css';

const Base = ({ children }) => (
  <div className={styles.main}>
    <Grid
      container
      alignItems="center"
      justify="center"
      spacing={0}
      direction="column"
    >
      <img
        alt="logo"
        src={logo}
        className={styles.image}
      />
      {children}
    </Grid>
  </div>
);

Base.propTypes = {
  children: propTypes.node.isRequired,
};

export default Base;
